<template>
  <div class="multi-patient" :class="$sn.validate.empty(functionConfig) ? 'sn-f-c-c' : 'sn-f-b-s'">
    <sn-no-data v-if="$sn.validate.empty(functionConfig)" message="缺少必要配置参数"></sn-no-data>
    <template v-else>
      <sn-navigator v-if="functionConfig.navigator" :id="functionConfig.navigator"></sn-navigator>
      <div class="sn-f-1 sn-f-col-b-s region">
        <sn-breadcrumb :breadcrumb="[{
          title: title
        }]"></sn-breadcrumb>
        <div class="sn-f-s-0 sn-f-b-c top-blank">
          <div class="sn-fs-24 sn-fw-bold sn-fc-text1">
            <template v-if="!isRecord">{{ patientList && patientList.length > 0 ? '请选择就诊人信息' : '请添加就诊人信息' }}</template>
            <template v-else>{{ $sn.format.getQuality(functionConfig, 'interaction.title') }}</template>
          </div>
            <div class="sn-f-s-0 sn-f-e-c interaction-blank">
            <template v-if="!isRecord">
              <div class="sn-f-c-c sn-pointer interaction" v-if="patientList && patientList.length < $sn.getConfig('patientStandard')"
              @click="navigateUrl('addition-patient');">添加就诊人</div>
            </template>
            <template v-else>
              <div class="sn-f-c-c sn-pointer interaction" @click="navigateUrl('exchange-patient');">切换就诊人</div>
            </template>
          </div>
        </div>
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient" v-if="isRecord && !$sn.validate.empty($sn.format.getQuality(functionConfig, 'step.swagger.date'))">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>查询日期：</div>
            </div>
            <el-date-picker class="range"
            start-placeholder="开始日期" end-placeholder="结束日期" type="daterange"  value-format="yyyy-MM-dd"
            v-model="range" :editable="false" :clearable="false"></el-date-picker>
          </div>
          <div class="sn-f-c-c sn-pointer interaction"
          :class="{'sn-silence': range.length !== 2}" @click="getRecordInfo('step');">查询</div>
        </div>
        <div class="sn-f-1 multi-blank">
          <template v-if="!isRecord">
            <sn-no-data v-if="!$sn.validate.array(patientList)" :message="false">
              <template v-slot>
                <div class="sn-f-c-c sn-pointer refresh" @click="handlePatientInfo();">刷新</div>
              </template>
            </sn-no-data>
            <template v-else>
              <template v-if="patientList.length > 0">
                <div class="sn-f-b-c sn-pointer multi-single" :class="{'interaction': patient.patientId === selectedPatient.patientId}" :key="patient.patientId" v-for="patient in patientList" @click="selectedPatient = patient;">
                  <div class="sn-f-1">
                    <div class="sn-f-s-c multi-line">{{ patient.patientName }}&nbsp;{{ $sn.format.sex(patient.patientSex) }}&nbsp;{{ $sn.format.ageByBirthday($sn.format.birthdayByIdCardSerial(patient.patientIdCardNo)) }}岁</div>
                    <div class="sn-f-s-c multi-line">{{ $sn.encrypted.idCardSerial(patient.patientIdCardNo) }}</div>
                  </div>
                  <div class="iconfont" :class="{
                    'icon-a-jianqu5 sn-fc-main3': patient.patientId === selectedPatient.patientId,
                    'icon-fangkuangweixuanzhong': patient.patientId !== selectedPatient.patientId
                  }"></div>
                </div>
              </template>
              <sn-no-data v-else></sn-no-data>
            </template>
          </template>
          <template v-else>
            <template v-if="recordInfo.length > 0">
              <div class="sn-pointer multi-single" :key="i" v-for="(record, i) in recordInfo" @click="goPrefix('interaction', {
                record: record
              });">
                <template v-if="['in-questionnaire', perpetual.IN_FUNCTION_PAYMENT_REMARK, perpetual.IN_FUNCTION_REPORT_REMARK].includes($route.params.mode)">
                  <div class="sn-f-s-c multi-line sn-fw-bold" v-if="record.inCardNo || record.inPatSerialNumber || record.inPatientNo">住院流水号：{{ record.inCardNo || record.inPatSerialNumber || record.inPatientNo }}</div>
                  <div class="sn-f-s-c multi-line sn-fw-bold" v-if="record.cardNo">住院号：{{ record.cardNo }}</div>
                  <div class="sn-f-s-c multi-line" v-if="record.admDept || record.deptName || record.inHospitalDept">
                    <span class="sn-omit">入院科室：{{ record.admDept || record.deptName || record.inHospitalDept }}</span>
                  </div>
                  <div class="sn-f-s-c multi-line" v-if="record.outHospitalDept">
                    <span class="sn-omit">出院科室：{{ record.outHospitalDept }}</span>
                  </div>
                  <div class="sn-f-s-c multi-line" v-if="record.createDate || record.inPatDate || record.inHospitalDate">入院时间：{{ record.createDate || record.inPatDate || record.inHospitalDate }}</div>
                  <div class="sn-f-s-c multi-line" v-if="record.outHospitalDate">出院时间：{{ record.outHospitalDate }}</div>
                </template>
                <template v-else-if="['out-questionnaire', 'complaint-suggest'].includes($route.params.mode)">
                  <div class="sn-f-s-c multi-line"><span class="sn-fw-bold">{{ record.doctorName }}</span>·{{ record.deptName }}</div>
                  <div class="sn-f-s-c multi-line" v-if="$sn.getConfig('isHosArea') && record.areaCode">就诊院区：{{ record.areaCode }}</div>
                  <div class="sn-f-s-c multi-line">就诊时间：{{ record.admDate }}</div>
                </template>
                <div class="sn-f-e-c multi-line">
                  <div class="sn-f-c-c interaction">{{ functionConfig.interaction.text || '选择' }}</div>
                </div>
              </div>
            </template>
            <sn-no-data v-else></sn-no-data>
          </template>
        </div>
        <div class="sn-f-s-0 sn-f-e-c interaction-blank">
          <template v-if="!isRecord">
            <div class="sn-f-c-c sn-pointer interaction sn-bc-blue1" v-if="!$sn.validate.empty(functionConfig.sub)"
            @click="$sn.format.getQuality(functionConfig, 'sub.disabled') !== '0' && !selectedPatient.patientId ? null : goPrefix('sub');">{{ functionConfig.sub.text }}</div>
            <div class="sn-f-c-c sn-pointer interaction"
            @click="$sn.format.getQuality(functionConfig, 'step.disabled') !== '0' && !selectedPatient.patientId ? null : goPrefix('step');">{{ functionConfig.step.text || '下一步' }}</div>
          </template>
          <template v-else>
            <div class="sn-f-c-c sn-pointer interaction" v-if="!$sn.validate.empty(functionConfig.record)"
            @click="goPrefix('record');">{{ functionConfig.record.text }}</div>
          </template>
        </div>
      </div>
    </template>
    <sn-tip-caption v-if="exhibitionTipCaption" :secretary="tipCaptionSecretary" @sendBack="sendBackTipCaption"></sn-tip-caption>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import CryptoJS from 'crypto-js';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config';

export default {
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin],
  data() {
    return {
      title: '',
      functionConfig: {},
      patientList: [],
      selectedPatient: {},
      range: [],
      recordInfo: [],
      selectedRecord: {},
      isRecord: false,
      //
      exhibitionTipCaption: false,
      tipCaptionSecretary: '',
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  watch: {
    '$route.params.mode': {
      handler: function(mode) {
        this.functionConfig = {};
        this.selectedPatient = {};
        this.recordInfo = [];
        this.selectedRecord = {};
        this.isRecord = false;
        /*
        noc[string]：须知类型
        card[boolean]：是否需要必须有卡
        id[string]：关联功能 ID；如为三方功能则直接为功能名称
        navigator[string]：左侧导航栏
        step[object]：选择就诊人按钮信息
          text[string]：选择就诊人按钮文案
          disabled[string]：未选择就诊人是否允许点击；如不允许为1；如允许为0
          swagger[object]：选择就诊人调用接口信息
            code[string]：通用转发接口码值
            type[string]：三方路由功能标识；如存在，则调用接口后直接进行跳转；如不存在，则展示相关记录
            platform[object]：平台项目相关入参
            patient[object]：就诊人相关入参
          storage[object]：选择就诊人后需存储缓存信息
          url[string]：选择就诊人后跳转路由信息
          params[object]：选择就诊人后跳转后续参数信息
          dynamics[array]：动态路由参数信息
        sub[object]：附属按钮信息，子项与上述用法相同
          ...
        interaction[object]：选择记录按钮信息，子项与上述用法相同
          title[string]：记录页面标题信息
          ...
        record[object]：记录底部按钮信息，子项与上述用法相同
          ...
        */
        const compare = {
          // 山东省立医院
          [this.perpetual.HOSPITAL_ID_SDSL]: {
            'out-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_MZMYDDC,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZMYDDC),
                'url': 'https://easy-ask.shunnengnet.com/s/Q4Nb84wd?ext=pc&sex={0}&age={1}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientSex',
                  'selectedPatient.dynamics.age'
                ]
              }
            },
            'in-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_ZYMYDDC,
              'navigator': 'WJDC',
              'step': {
                'swagger': {
                  'code': '369c2056-d0f6-4f6d-9995-97550eb85157',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId',
                    'PatName': 'patientName',
                    'PatIdCardNo': 'patientIdCardNo'
                  }
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': 'https://care.iflyhealth.com/pcm-front/#/questionnaire/qrcode-questionnaire/96-173458857761177718?info={0}',
                'params': ''
              }
            },
            'complaint-suggest': {
              'id': this.perpetual.FUNCTION_ID_TSYJY,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TSYJY),
                'swagger': {
                  'code': 'f0ada48e-0d0f-4c9c-bd12-c5ee9f3001e4',
                  'platform': {
                    'StartDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -90, 'day'),
                    'EndDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')
                  },
                  'patient': {
                    'IdCardNo': 'patientIdCardNo',
                    'PatName': 'patientName'
                  }
                }
              },
              'sub': {
                'text': '查看办理进度',
                'disabled': '0',
                'url': 'https://easy-ask.shunnengnet.com/q/9aEUTSWU?qid=41&phone={0}',
                'params': '',
                'dynamics': ['$sn.utils.getLoginPhone']
              },
              'interaction': {
                'title': '请选择就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/9aEUTSWU?ext=pc&patientName={0}&patientIdCardNo={1}&outCardId={2}&phone={3}&area={4}&centreArea={5}&eastArea={6}&respondent={7}&admNo={8}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientName',
                  'selectedPatient.patientIdCardNo',
                  'selectedPatient.outCardId',
                  '$sn.utils.getLoginPhone',
                  'selectedRecord.areaCode',
                  'selectedRecord.deptName',
                  'selectedRecord.deptName',
                  'selectedRecord.doctorName',
                  'selectedRecord.admRowId'
                ]
              },
              'record': {
                'text': '其他就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/9aEUTSWU?ext=pc&patientName={0}&patientIdCardNo={1}&outCardId={2}&phone={3}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientName',
                  'selectedPatient.patientIdCardNo',
                  'selectedPatient.outCardId',
                  '$sn.utils.getLoginPhone'
                ]
              }
            },
            [this.perpetual.IN_FUNCTION_PAYMENT_REMARK]: {
              'id': this.perpetual.FUNCTION_ID_ZYFY,
              'navigator': 'FYCX',
              'step': {
                'swagger': {
                  'code': '369c2056-d0f6-4f6d-9995-97550eb85157',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId',
                    'PatName': 'patientName',
                    'PatIdCardNo': 'patientIdCardNo'
                  }
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': '/query/payment',
                'params': {
                  'type': '2'
                }
              }
            },
            [this.perpetual.IN_FUNCTION_REPORT_REMARK]: {
              'id': this.perpetual.FUNCTION_ID_ZYBG,
              'navigator': 'BGCX',
              'step': {
                'swagger': {
                  'code': '369c2056-d0f6-4f6d-9995-97550eb85157',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId',
                    'PatName': 'patientName',
                    'PatIdCardNo': 'patientIdCardNo'
                  }
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': '/query/report',
                'params': {
                  'type': '2'
                }
              }
            }
          },
          // 聊城市人民医院
          [this.perpetual.HOSPITAL_ID_LCRM]: {
            'out-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_MZMYDDC,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZMYDDC),
                'swagger': {
                  'code': 'cc7a5ea7-4a35-40da-9394-7c35b233cef1',
                  'platform': {
                    'StartDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -90, 'day'),
                    'EndDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'),
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'interaction': {
                'title': '请选择就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/sLIwnrV5?ext=pc&sex={0}&age={1}&admNo={2}&deptName={3}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientSex',
                  'selectedPatient.dynamics.age',
                  'selectedRecord.admRowId',
                  'selectedRecord.deptName'
                ]
              }
            },
            'in-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_ZYMYDDC,
              'navigator': 'WJDC',
              'step': {
                'swagger': {
                  'code': '6f309a47-a80e-40e2-9042-d88038f8b6ca',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': 'https://easy-ask.shunnengnet.com/s/VEFHWGVe?ext=pc&deptName={0}&admNo={1}',
                'params': '',
                'dynamics': [
                  'selectedRecord.deptName',
                  'selectedRecord.inPatSerialNumber'
                ]
              }
            },
            'complaint-suggest': {
              'id': this.perpetual.FUNCTION_ID_TSYJY,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TSYJY),
                'swagger': {
                  'code': 'cc7a5ea7-4a35-40da-9394-7c35b233cef1',
                  'platform': {
                    'StartDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -90, 'day'),
                    'EndDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'),
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'sub': {
                'text': '查看办理进度',
                'disabled': '0',
                'url': 'https://easy-ask.shunnengnet.com/q/JkJVttJ2?qid=50&phone={0}',
                'params': '',
                'dynamics': ['$sn.utils.getLoginPhone']
              },
              'interaction': {
                'title': '请选择就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/JkJVttJ2?ext=pc&patientName={0}&patientIdCardNo={1}&phone={2}&admNo={3}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientName',
                  'selectedPatient.patientIdCardNo',
                  '$sn.utils.getLoginPhone',
                  'selectedRecord.admRowId'
                ]
              }
            }
          },
          // 山东大学齐鲁医院
          [this.perpetual.HOSPITAL_ID_SDQL]: {
            'out-cloud-film': {
              'id': this.perpetual.FUNCTION_ID_MZYJP,
              'navigator': 'BGCX',
              'step': {
                'text': '查询',
                'url': 'https://medimage.qiluhospital.com/auth/idcard/list?hospital_code=0531_1216&phone_number={0}&id_card={1}',
                'params': '',
                'dynamics': [
                  'selectedPatient.encrypted.patientPhone',
                  'selectedPatient.encrypted.patientIdCardNo'
                ]
              }
            },
            [this.perpetual.IN_FUNCTION_REPORT_REMARK]: {
              'id': this.perpetual.FUNCTION_ID_ZYBG,
              'navigator': 'BGCX',
              'step': {
                'swagger': {
                  'code': '34194e4f-f9ec-4a07-baec-e19382e17f79',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  },
                  'start': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -6, 'month'),
                  'date': ['StartDate', 'EndDate']
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': '/query/report',
                'params': {
                  'type': '2'
                }
              }
            }
          },
          // 山东省肿瘤医院
          [this.perpetual.HOSPITAL_ID_SDSZL]: {
            'out-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_MZMYDDC,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_MZMYDDC),
                'swagger': {
                  'code': 'daa3975b-e297-4f79-a6ab-8fd10309661b',
                  'platform': {
                    'StartDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -90, 'day'),
                    'EndDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'),
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'interaction': {
                'title': '请选择就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/ZYDmK5LM?ext=pc&sex={0}&age={1}&admNo={2}&deptName={3}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientSex',
                  'selectedPatient.dynamics.age',
                  'selectedRecord.admRowId',
                  'selectedRecord.deptName'
                ]
              }
            },
            'in-questionnaire': {
              'id': this.perpetual.FUNCTION_ID_ZYMYDDC,
              'navigator': 'WJDC',
              'step': {
                'swagger': {
                  'code': 'c700eb7f-46ae-48bd-a0d0-db292b3831b6',
                  'platform': {
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'interaction': {
                'title': '请选择住院信息',
                'url': 'https://easy-ask.shunnengnet.com/s/pxFdldq0?ext=pc&deptName={0}&admNo={1}',
                'params': '',
                'dynamics': [
                  'selectedRecord.inHospitalDept',
                  'selectedRecord.inPatientNo'
                ]
              }
            },
            'complaint-suggest': {
              'id': this.perpetual.FUNCTION_ID_TSYJY,
              'navigator': 'WJDC',
              'step': {
                'text': this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_TSYJY),
                'swagger': {
                  'code': 'daa3975b-e297-4f79-a6ab-8fd10309661b',
                  'platform': {
                    'StartDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', -90, 'day'),
                    'EndDate': this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'),
                    'PlatformId': this.$sn.utils.getPlatformType(),
                    'PlatformUserId': this.$sn.utils.getOpenId()
                  },
                  'patient': {
                    'PatId': 'patientId'
                  }
                }
              },
              'sub': {
                'text': '查看办理进度',
                'disabled': '0',
                'url': 'https://easy-ask.shunnengnet.com/q/poI2lzgk?qid=118&phone={0}',
                'params': '',
                'dynamics': ['$sn.utils.getLoginPhone']
              },
              'interaction': {
                'title': '请选择就诊记录',
                'url': 'https://easy-ask.shunnengnet.com/s/poI2lzgk?ext=pc&patientName={0}&patientIdCardNo={1}&phone={2}&admNo={3}',
                'params': '',
                'dynamics': [
                  'selectedPatient.patientName',
                  'selectedPatient.patientIdCardNo',
                  '$sn.utils.getLoginPhone',
                  'selectedRecord.admRowId'
                ]
              }
            }
          }
        };
        if (!this.$sn.validate.empty(this.$sn.format.getQuality(compare, this.$sn.utils.getHospitalId() + '.' + mode))) {
          this.functionConfig = this.$sn.format.getQuality(compare, this.$sn.utils.getHospitalId() + '.' + mode);
          if (this.functionConfig.noc && this.$sn.utils.verifyTipCaption(this.functionConfig.noc)) {
            this.tipCaptionSecretary = this.functionConfig.noc;
            this.$sn.utils.storeTipCaption(this.tipCaptionSecretary);
            this.exhibitionTipCaption = true;
          }
          this.title = this.$sn.utils.getHospitalTitle();
          if (this.functionConfig.id) {
            if (this.$sn.validate.chinese(this.functionConfig.id)) this.title = this.functionConfig.id;
            else if (this.$sn.utils.getFunctionTitle('0', this.functionConfig.id)) this.title = this.$sn.utils.getFunctionTitle('0', this.functionConfig.id);
          }
          if (!this.$sn.validate.empty(this.$sn.format.getQuality(this.functionConfig, 'step.swagger.date'))) {
            this.range = [
              (this.$sn.format.getQuality(this.functionConfig, 'step.swagger.start') || this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')),
              this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')
            ];
          }
          document.title = this.title;
          this.$route.meta.title = this.title;
        }
      },
      immediate: true
    }
  },
  created: function() {
    if (this.$sn.utils.getHospitalSessionStorage('MultiPatient_PatientInfo')) {
      this.$sn.utils.removeHospitalSessionStorage('MultiPatient_PatientInfo');
    }
    if (this.$sn.utils.getHospitalSessionStorage('MultiPatient_RecordInfo')) {
      this.$sn.utils.removeHospitalSessionStorage('MultiPatient_RecordInfo');
    }
    this.handlePatientInfo();
  },
  methods: {
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
    },
    async goPrefix(type, params) {
      const config = this.functionConfig[type];
      if (type === 'step') {
        if (this.functionConfig.card) {
          const handle = await Tools.handlePatientInfo(this.selectedPatient);
          if (![0, 3, 4].includes(handle.code)) {
            this.$sn.assembly.modal({
              caption: Messages.RECHARGE012,
              success: (model) => {
                if (model.confirm) {
                  this.navigateUrl('addition-card', this.selectedPatient);
                }
              }
            });
            return false;
          }
        }
        if (!this.$sn.validate.empty(config.swagger)) {
          this.getRecordInfo(type);
          return false;
        }
      }
      if (!this.$sn.validate.empty(config.storage)) {
        const storage = config.storage;
        Object.keys(storage).forEach(type => {
          if (['Local', 'Session'].includes(type)) {
            Object.keys(storage[type]).forEach(title => {
              this.$sn.utils['setHospital' + type + 'Storage'](title, storage[type][title]);
            });
          }
        });
      }
      if (type === 'interaction' && !this.$sn.validate.empty(params.record)) {
        this.selectedRecord = params.record;
        this.$sn.utils.setHospitalSessionStorage('MultiPatient_RecordInfo', this.selectedRecord);
      }
      this.$sn.utils.setHospitalSessionStorage('MultiPatient_PatientInfo', this.selectedPatient);
      if (!this.$sn.validate.empty(config.dynamics)) {
        if (!this.$sn.validate.empty(config.dynamics.find(result => result.indexOf('dynamics.age') > -1))) {
          const birthday = this.selectedPatient.patientBirthday || this.$sn.format.birthdayByIdCardSerial(this.selectedPatient.patientIdCardNo);
          const age = this.$sn.format.ageByBirthday(birthday);
          let standard = '4';
          if (this.$sn.validate.range(age, [18, 30])) standard = '2';
          else if (this.$sn.validate.range(age, [31, 59])) standard = '3';
          else if (age < 18) standard = '1';
          this.$sn.format.setQuality(this.selectedPatient, 'dynamics.age', standard);
        }
        if (!this.$sn.validate.empty(config.dynamics.find(result => result.indexOf('.encrypted.') > -1))) {
          let encrypted;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
            encrypted = (variable) => {
              const key = CryptoJS.enc.Utf8.parse('PEIotNBnBTN7uquQ');
              const iv = CryptoJS.enc.Utf8.parse('zEXaPrpd67fPrkMr');
              const result = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(variable), key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
              });
              return result.ciphertext.toString();
            };
          }
          if (this.$sn.validate.func(encrypted)) {
            config.dynamics.forEach(el => {
              const variable = this.$sn.format.getQuality(this, el.replace('.encrypted', ''));
              if (variable) this.$sn.format.setQuality(this, el, encrypted(variable));
            });
          }
        }
        const dynamics = [];
        config.dynamics.forEach(el => {
          let text = '';
          if (el.indexOf('$sn') > -1) text = this.$sn.format.getQuality(this, el)();
          else text = this.$sn.format.getQuality(this, el);
          dynamics.push(text);
        });
        config.url = this.$sn.format.caption(config.url, dynamics);
      }
      if (type === 'interaction' && this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.$route.params.mode === 'in-questionnaire') {
        const suffix = {
          name: this.selectedPatient.patientName,
          mobile: this.selectedPatient.patientPhone,
          source: '官网',
          dep: this.selectedRecord.admDept,
          doc: '',
          outpatientTime: '',
          dischargeTime: this.selectedRecord.createDate
        };
        let handle = JSON.stringify(suffix);
        handle = CryptoJS.enc.Utf8.parse(encodeURIComponent(handle)).toString(CryptoJS.enc.Base64);
        handle = handle.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        config.url = this.$sn.format.caption(config.url, [handle]);
      }
      this.navigateUrl(config.url, '', config.params);
    },
    getRecordInfo(type) {
      const config = this.functionConfig[type];
      const swagger = config.swagger;
      const xml = swagger.platform || {};
      if (!this.$sn.validate.empty(swagger.patient)) {
        if (swagger.type) {
          this.$set(xml, 'Type', swagger.type);
          this.$set(xml, 'Data', {});
          Object.keys(swagger.patient).forEach(key => {
            this.$set(xml.Data, key, this.selectedPatient[swagger.patient[key]]);
          });
          xml.Data = JSON.stringify(xml.Data);
        }
        else {
          Object.keys(swagger.patient).forEach(key => {
            this.$set(xml, key, this.selectedPatient[swagger.patient[key]]);
          });
          if (!this.$sn.validate.empty(swagger.date)) {
            swagger.date.forEach((key, i) => {
              this.$set(xml, key, this.range[i]);
            });
          }
        }
      }
      const params = {
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), swagger.code]),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml(xml))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                if (!this.$sn.validate.empty(result.data.Data)) {
                  if (swagger.type) {
                    this.navigateUrl(result.data.Data.url);
                  }
                  else {
                    this.recordInfo = result.data.Data;
                    this.isRecord = true;
                  }
                }
                else {
                  if (!swagger.type && !this.$sn.validate.empty(swagger.date)) this.isRecord = true;
                  this.$sn.assembly.modal({
                    caption: Messages.C002,
                    isCancel: false
                  });
                }
              }
              else {
                if (!swagger.type && !this.$sn.validate.empty(swagger.date)) this.isRecord = true;
                this.$sn.assembly.modal({
                  caption: result.data.ResultMsg,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.C002,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    sendBackTipCaption(type) {
      if (type) {}
      this.exhibitionTipCaption = false;
      this.tipCaptionSecretary = '';
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else if (url === 'exchange-patient') {
        if (this.$sn.utils.getHospitalSessionStorage('MultiPatient_PatientInfo')) {
          this.$sn.utils.removeHospitalSessionStorage('MultiPatient_PatientInfo');
        }
        if (this.$sn.utils.getHospitalSessionStorage('MultiPatient_RecordInfo')) {
          this.$sn.utils.removeHospitalSessionStorage('MultiPatient_RecordInfo');
        }
        this.selectedPatient = {};
        this.recordInfo = [];
        this.selectedRecord = {};
        this.isRecord = false;
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.multi-patient {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .region {
    overflow: hidden;
    height: 100%;

    .top-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px;

      .interaction-blank {
        width: max-content;
        padding: 0;
      }
    }

    .sn-header-patient {
      width: calc(100% - 40px);
      margin: 0 20px 20px;
    }

    .multi-blank {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;
      padding: 0 20px;

      .refresh {
        @include fs(14);

        overflow: hidden;
        width: 100px;
        height: 40px;
        background-color: $main3;
        color: $white;
        border-radius: 5px;
      }

      .multi-single {
        @include fs(14);

        float: left;
        overflow: hidden;
        width: 32%;
        color: $text1;
        border: 1px solid $border1;
        border-radius: 4px;
        padding: 0 20px;
        margin-right: 2%;
        margin-bottom: 20px;

        &:nth-child(3n+3) {
          margin-right: 0;
        }

        &.interaction {
          color: $main3;
          border: 1px solid $main3;

          .multi-line {
            border-bottom: 1px dashed $main3;
          }
        }

        .multi-line {
          width: 100%;
          height: 40px;
          border-bottom: 1px dashed $border1;

          &:last-child {
            border-bottom: none;
          }

          .interaction {
            height: 30px;
            background-color: $main3;
            color: $white;
            border-radius: 15px;
            padding: 0 20px;
          }
        }

        .iconfont {
          font-size: 18px;
          color: $border1;
          margin-left: 20px;
        }
      }
    }

    .interaction-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px;

      .interaction {
        @include fs(14);

        overflow: hidden;
        width: 200px;
        height: 40px;
        background-color: $main3;
        color: $white;
        border-radius: 5px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
